import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  GraduationCap,
  Users,
  UserCheck,
  Building,
  Briefcase,
  DollarSign,
} from 'lucide-react';
import { KPICard } from '../widgets/KPICard';

export function KPIOverviewRow({ kpis, loading }) {
  const navigate = useNavigate();

  if (loading || !kpis) {
    return (
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
        {[...Array(6)].map((_, i) => (
          <div
            key={i}
            className="h-[120px] bg-white border border-stone-200/80 rounded-xl animate-pulse"
          />
        ))}
      </div>
    );
  }

  const cards = [
    {
      title: 'Total Students',
      value: kpis.students?.total || 0,
      growth: kpis.students?.growth,
      icon: GraduationCap,
      color: 'blue',
      onClick: () => navigate('/admin/students'),
    },
    {
      title: 'Active Agents',
      value: kpis.agents?.total || 0,
      growth: kpis.agents?.growth,
      icon: Users,
      color: 'green',
      onClick: () => navigate('/admin/agents'),
    },
    {
      title: 'Counselors',
      value: kpis.counselors?.total || 0,
      growth: kpis.counselors?.growth,
      icon: UserCheck,
      color: 'purple',
      onClick: () => navigate('/admin/counselors'),
    },
    {
      title: 'Universities',
      value: kpis.universities?.total || 0,
      growth: kpis.universities?.growth,
      icon: Building,
      color: 'amber',
      onClick: () => navigate('/admin/universities'),
    },
    {
      title: 'Services',
      value: kpis.services?.total || 0,
      growth: kpis.services?.growth,
      icon: Briefcase,
      color: 'indigo',
      onClick: () => navigate('/admin/services'),
    },
    {
      title: 'Total Revenue',
      value: kpis.revenue?.total || 0,
      growth: kpis.revenue?.growth,
      icon: DollarSign,
      color: 'rose',
      type: 'currency',
      onClick: () => navigate('/admin/reports'),
    },
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
      {cards.map((card, index) => (
        <KPICard key={card.title} {...card} delay={index * 0.05} />
      ))}
    </div>
  );
}

export default KPIOverviewRow;
